import { Delete, Edit } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'
import { useReadOnlyTooltipData } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { intl } from '@/intl'
import { getRecurrenceLabel } from '@/server-data'

import { useDeleteDriverAssignmentModal } from '../../../../../modals/DeleteDriverAssignmentModal'
import { useRecurrence } from '../../../hooks/useRecurrence'
import { useActions } from '../hooks/useActions'
import { useTexts } from '../hooks/useTexts'

interface Props {
  driverAssignmentId: string
}

export function Header(props: Props) {
  const { driverAssignmentId } = props
  const recurrence = useRecurrence()
  const actions = useActions(driverAssignmentId)
  const texts = useTexts()
  const { Modal: DeleteDriverAssignmentModal } = useDeleteDriverAssignmentModal()

  // Ignore courier read-only reason, but respect other read-only reasons
  const { preventEditing, title: readOnlyTitle } = useReadOnlyTooltipData(undefined, ['courier'])

  const title = recurrence
    ? getRecurrenceLabel(recurrence.type, recurrence.value, intl.translate)
    : ''

  const description = recurrence ? texts.recurrenceDescription(recurrence.type) : ''

  // "Normal Day" (any recurrence / default assignment) cannot be deleted
  const isDefaultAssignment = recurrence?.type === 'any'
  const deleteDisabled = isDefaultAssignment || preventEditing

  return (
    <preview.Header
      title={title}
      subtitle={description}
      testId="driver-assignment-view-header"
      onClose={actions.onReset}
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={actions.onEdit}
          label={texts.edit}
          disableWhenReadOnly={false}
          disabled={preventEditing}
          tooltip={preventEditing ? readOnlyTitle : texts.edit}
          testId="setup-vehicleassignment__edit"
          data-trackid="setup-vehicleassignment__edit"
        />
        <preview.ActionBarItem
          icon={<Delete />}
          onClick={actions.onDelete}
          label={texts.delete}
          disableWhenReadOnly={false}
          disabled={deleteDisabled}
          tooltip={
            isDefaultAssignment
              ? texts.deleteNormalDay
              : preventEditing
                ? readOnlyTitle
                : texts.delete
          }
          testId="setup-vehicleassignment__delete"
          data-trackid="setup-vehicleassignment__delete"
        />
      </preview.ActionBar>

      <DeleteDriverAssignmentModal driverAssignmentIds={[driverAssignmentId]} />
    </preview.Header>
  )
}
